export enum Routes {
  BASE = '/',
  CAMPAINGS = 'campaings',
  DETAILS = 'details',
  CREATE = 'create',
  EDIT = 'edit',
  ACTIVITY = 'activity',
  ACTIVITIES = 'activities',
  ACTIVITY_TYPE_PARAM = ':activityType',
  ACTIVITY_TYPE_ID = ':activityId',
  ADD = 'add',
  DAY = 'day',
  SURVEY = 'survey',
  QUESTION = 'question',
  AWARDS = 'awards',
  INVOICES = 'invoices',
  TOURS = 'tours',
  SHORT_ANSWER = 'short-answer',
  UNIQUE_OPTION = 'unique-option',
  PARAGRAPH = 'paragraph',
  MULTIPLE_OPTION = 'multiple-option',
  PICTURE = 'picture',
  MANAGE_PERSONAL = 'manage-personal',
  MANAGE_ACTIVITIES = 'manage-activities',
  ID_CAMPAIGN_PARAM = ':idCampaign',
  ID_DAY_PARAM = ':idDay',
  SURVEY_ANSWERS = 'survey-answers',
  ACTIVITY_ANSWERS = 'activity-answers',
  CONFIG_ACTIVITY_ID_PARAM = ':configActivityId',
  USER_ID_PARAM = ':userId',
  LOGIN = 'login',
  CHECKIN = 'check-in',
  EMERGENCY = 'emergency',
  PROGRESS = 'progress',
  DASHBOARD = 'dashboard',
  SUPERVISOR = 'supervisor',
  SELECT_PERSONAL = 'select-personal',
}
